module.exports = __webpack_public_path__ + "img/zealtechpos.a799fc22.png";